/**
 * Appels API pour les To Dos.
 */

import api from "./axiosConfig";

/**
 * Récupère la liste des To Dos de l'utilisateur.
 * @param {string} sortBy - Critère de tri.
 * @returns {Promise<Array>} Liste des todos.
 */
export async function getTodos(sortBy = "due_date", status = null) {
  let url = `/todos?sort_by=${sortBy}`;
  if (status) url += `&status=${status}`;
  const response = await api.get(url);
  return response.data;
}

/**
 * Récupère un To Do par son ID.
 * @param {number} id - Identifiant du todo.
 * @returns {Promise<Object>} Le todo.
 */
export async function getTodo(id) {
  const response = await api.get(`/todos/${id}`);
  return response.data;
}

/**
 * Crée un nouveau To Do.
 * @param {Object} data - Données du todo.
 * @returns {Promise<Object>} Le todo créé.
 */
export async function createTodo(data) {
  const response = await api.post("/todos", data);
  return response.data;
}

/**
 * Met à jour un To Do existant.
 * @param {number} id - Identifiant du todo.
 * @param {Object} data - Champs à modifier.
 * @returns {Promise<Object>} Le todo mis à jour.
 */
export async function updateTodo(id, data) {
  const response = await api.put(`/todos/${id}`, data);
  return response.data;
}

/**
 * Supprime un To Do.
 * @param {number} id - Identifiant du todo.
 * @returns {Promise<void>}
 */
export async function deleteTodo(id) {
  await api.delete(`/todos/${id}`);
}
